import { enumObject, EnumObjectValue } from '@app/base';

export const GlaucomaTestType = enumObject('GlaucomaTestType', [
  'va',
  'va2m',
  'sf',
  'vf',
  'mlf',
  'llcva',
  '30_2f',
  'bf',
] as const);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type GlaucomaTestType = EnumObjectValue<typeof GlaucomaTestType>;

export interface CreateGlaucomaTestsRequest {
  id: string;
  tests: GlaucomaTestType[];
  comments: string | null;
}

export interface GlaucomaTests {
  portalUrl: string | null;
}

export interface GlaucomaImageFile {
  fileName: string;
  contentType: string;
  data: string;
}

export interface GlaucomaTestAttemptResult {
  teleportId: string;
  resultReceivedAt: string | null;
}
